import { Center } from '@mantine/core'
import React, { useCallback, useEffect, useState } from 'react'

import { useApplicationContext } from '../../../contexts'
import { getAuthFile } from '../../../utils'
import type { FileItemProps, PreviewFile } from '../types'

export const AudioFile = ({ file, ...rest }: FileItemProps) => {
    const [authFile, setAuthFile] = useState<PreviewFile | undefined>(undefined)
    const { fetchAVPlayUrl } = useApplicationContext()
    const fetchAuthFile = useCallback(async () => {
        const authFile = await getAuthFile(file, fetchAVPlayUrl)
        setAuthFile(authFile)
    }, [file, fetchAVPlayUrl])

    useEffect(() => {
        fetchAuthFile()
    }, [fetchAuthFile])

    return (
        <Center sx={{ height: '100%' }}>
            <audio src={authFile?.url} controls controlsList="nodownload noplaybackrate" preload="metadata" {...rest}>
                您的浏览器版本较低，不支持该功能，请升级至最新版本
            </audio>
        </Center>
    )
}
